import { updateAccount } from '../actions/PaymentsHistorySMEActionCreator';
import FavouritesActionCreator from '../actions/AccountsActionCreator/FavouritesActionCreator';
import InternetBankingActions from '../actions/InternetBankingActions';

export const handleChooseAccountFromPicker = (e) => {
  e.preventDefault();
  FavouritesActionCreator.saveAccountPickerActions({
    backUrl: 'WEB-MANAGE-PAYMENT-STATUS',
    onSelectAccount: (account) => {
      updateAccount(account.id);
      InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT-STATUS');
    },
  });
  InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-PICKER');
};
